// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"131":"a681b348","787":"408ee0f0"}[chunkId] + ".chunk.js";
};